import React from "react";
import "./InputWrapper.scss";

export default function(props: { children: any }) {
  return <div className="InputWrapper">{props.children}</div>;
}
